import React, {forwardRef, PropsWithChildren} from 'react';

import {ActivityWithIcon} from './activityWithIcon';

/*
 * Props.
 */

interface ActivityWithRuleIconProps {
  isMacro?: boolean;
}

/*
 * Component.
 */

export const ActivityWithRuleIcon = forwardRef<HTMLDivElement, PropsWithChildren<ActivityWithRuleIconProps>>(
  ({isMacro, children}, ref) => (
    <ActivityWithIcon iconName={isMacro ? 'lightning' : 'gearActivity'} ref={ref}>
      {children}
    </ActivityWithIcon>
  ),
);
